<template>
  <a
    :class="[`shrimp-banner-full`]"
    href="https://bridge.liquidswap.com/wormhole-widget"
  >
    <div :class="[`shrimp-banner-full__background-gradient`]">
      <img
        alt="background"
        class="image-gradient"
        src="@/assets/banners/wormhole-banner.png"
      />
    </div>
  </a>
</template>
<script lang="ts" setup></script>

<style lang="scss" scoped>
.shrimp-banner-full {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 84px;
  border-radius: 10px;
  background: #abaeff21;
  cursor: pointer;
  overflow: hidden;

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 84px;
  }
}

.shrimp-banner-short {
  display: flex;
  position: relative;
  width: 100%;
  height: 51px;
  margin-bottom: 10px;
  align-items: center;
  border-radius: 10px;
  background: #abaeff21;
  gap: 15px;
  overflow: hidden;

  @media (max-width: 400px) {
    gap: 0;
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 51px;
  }
}

.image-gradient {
  height: 100%;
  width: 100%;
}
</style>
